// App page formgroup
export const linkedItemFormGroup = function(pageItem) {
  return this.formBuilder.group({
    item_uuid: [pageItem.itemUUID],
    name: [pageItem.name],
    uuid: [pageItem.uuid]
  });
}